export default function reduxConstants(namespace, names) {
  return names.reduce((acc, name) => ({
    ...acc,
    [name]: `${namespace}.${name}`
  }), {});
}

